import { useState, useRef, useEffect } from "react";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import { FaCalendarAlt } from "react-icons/fa";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

function BookingCard({ checkIn, checkOut, setCheckIn, setCheckOut }) {

  const [open, setOpen] = useState(false);
  const ref = useRef();

  const [date, setDate] = useState([
    {
      startDate: checkIn ? new Date(checkIn) : new Date(),
      endDate: checkOut ? new Date(checkOut) : new Date(),
      key: "selection",
    },
  ]);
  useEffect(() => {
  const today = new Date();
  today.setHours(0,0,0,0);

  if (date[0].startDate < today) {
    setDate([
      {
        startDate: today,
        endDate: today,
        key: "selection",
      },
    ]);
  }
}, []);

  // 🔥 CLICK OUTSIDE
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleApply = () => {
    const start = date[0].startDate;
    const end = date[0].endDate;

    setCheckIn(start.toISOString().split("T")[0]);
    setCheckOut(end.toISOString().split("T")[0]);

    setOpen(false);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-5 shadow-sm">

      <h3 className="text-lg font-semibold mb-4">
        Vérifier la disponibilité
      </h3>

      <div ref={ref} className="relative">

        {/* 🔥 INPUT */}
        <div
          onClick={() => setOpen(!open)}
          className="
            w-full flex items-center gap-2
            border border-gray-300 rounded-xl px-3 py-2
            text-sm cursor-pointer hover:border-gray-400
          "
        >
          <FaCalendarAlt className="text-gray-500" />

          {checkIn && checkOut
            ? `${format(new Date(checkIn), "dd/MM")} → ${format(new Date(checkOut), "dd/MM")}`
            : "Sélectionner vos dates"}
        </div>

        {/* 🔥 CALENDAR */}
        {open && (
          <div
            className="
              absolute z-50 mt-2
              bg-white border border-gray-200 rounded-xl shadow-lg
              p-2
            "
          >
            <DateRange
              ranges={date}
              onChange={(item) => setDate([item.selection])}
              moveRangeOnFirstSelection={false}
              rangeColors={["#3A9D23"]}
              months={1}
              direction="vertical"
              showDateDisplay={false}
              minDate={new Date()}
            />

            {/* 🔥 ACTION */}
            <div className="flex justify-end mt-2">
              <button
                onClick={handleApply}
                className="
                  px-4 py-2 text-sm rounded-lg
                  bg-[#3A9D23] text-white hover:bg-[#33891E]
                "
              >
                Valider
              </button>
            </div>
          </div>
        )}

      </div>

      {/* FEEDBACK */}
      {checkIn && checkOut && (
        <p className="text-xs text-green-600 mt-3">
          ✓ Disponibilités mises à jour
        </p>
      )}

    </div>
  );
}

export default BookingCard;